import * as ActionTypes from './ActionTypes';


export const Comments = (state = {
    errMess: null,
    dailylogs: []
}, action) => {
    switch (action.type) {
        case ActionTypes.ADD_COMMENTS:
            return { ...state, isLoading: false, errMess: null, dailylogs: action.payload };


        case ActionTypes.COMMENTS_FAILED:
            return { ...state, isLoading: false, errMess: action.payload, dailylogs: [] };

        case ActionTypes.ADD_COMMENT:
            var dailylogs = action.payload;
            return { ...state, dailylogs: state.dailylogs.concat(dailylogs) };

        /*case ActionTypes.ADD_TASK:
            var dailylogs = action.payload;
            const updatedLog = state.dailylogs.map(dailylog => {
                if (dailylog.id == dailylogs.id) {
                    return { ...dailylog, subtasks: dailylogs.subtasks };
                }
                return dailylog;
            })
            // var dailylogs = action.payload;                                
            return { ...state, dailylogs: updatedLog };*/
        case ActionTypes.SAVE_UPDATE_TO_LOG:
            const index = state.dailylogs.findIndex(object => {
                return object.id === action.payload.id;
            });
            state.dailylogs[index].subject = action.payload.subject;
            state.dailylogs[index].topic = action.payload.topic;
            state.dailylogs[index].subtopic = action.payload.subtopic;
            state.dailylogs[index].comments = action.payload.comments;
            state.dailylogs[index].noOfTasks = action.payload.noOfTasks;
            state.dailylogs[index].noOfDoneTasks = action.payload.noOfDoneTasks;
            return { ...state, dailylogs: state.dailylogs };

        default:
            return state;
    }
}

export const Timetables = (state = {
    isLoading: true,
    errMess: null,
    timetables: []
}, action) => {
    switch (action.type) {

        case ActionTypes.ADD_TIMETABLE:
            var timetables = action.payload;
            return { ...state, timetables: state.timetables.concat(timetables) };
        case ActionTypes.DELETE_TIMETABLE:
            const timetableIdToDelete = action.payload;
            const updatedTimetables = state.timetables.filter(timetable => timetable._id !== timetableIdToDelete);
            return { ...state, timetables: updatedTimetables };
        case ActionTypes.GET_TIMETABLES:
            var timetables = action.payload;
            return { ...state, timetables: timetables };
        case ActionTypes.UPDATE_TIMETABLE:
            var timetables = action.payload;
            const index = state.timetables.findIndex(object => {
                return object._id === action.payload._id;
            });
            state.timetables[index].schedule = action.payload.schedule;
            state.timetables[index].subject = action.payload.subject;
            state.timetables[index].referenceWeekStartDate = action.payload.referenceWeekStartDate;

            return { ...state, timetables: state.timetables };
        default:
            return state;
    }
}

export const Alltasks = (state = {
    isLoading: true,
    errMess: null,
    alltasks: []
}, action) => {
    switch (action.type) {
        case ActionTypes.TASKS_FAILED:            
            return { ...state, alltasks: [] };
        case ActionTypes.GET_ALL_TASKS:
            var tasks = action.payload;
            return { ...state, alltasks: tasks };
        case ActionTypes.ADD_TASK:
            var tasks = action.payload;
            const index = state.alltasks.findIndex(object => {
                return object.id === action.payload.id;
            });
            state.alltasks[index].tasks = action.payload.tasks;

            return { ...state, alltasks: state.alltasks };
        case ActionTypes.ADD_TASK_TO_ALLTASKS:
            return { ...state, alltasks: state.alltasks.concat(action.payload) };
        case ActionTypes.UPDATE_TASK_TO_ALL_TASKS:
            var tasks = action.payload;
            const tskIndex = state.alltasks.findIndex(object => {
                return object._id === action.payload._id;
            });
            state.alltasks[tskIndex] = action.payload;

            return { ...state, alltasks: state.alltasks };

        default:
            return state;
    }
}

export const Tasks = (state = {
    isLoading: true,
    errMess: null,
    tasks: []
}, action) => {
    switch (action.type) {
        case ActionTypes.ADD_TASKS:
            return { ...state, isLoading: false, errMess: null, tasks: action.payload };
        case ActionTypes.ADD_TASK:
            var tasks = action.payload;
            return { ...state, tasks: tasks };
        case ActionTypes.TASKS_FAILED:
            return { ...state, isLoading: false, errMess: action.payload, tasks: [] };
        case ActionTypes.TASKS_LOADING:
            return { ...state, isLoading: true, errMess: "error-test", tasks: [] };

        default:
            return state;
    }
}

export const Log = (state = {
    isLoading: true,
    errMess: null,
    tasks: []
}, action) => {
    switch (action.type) {
        case ActionTypes.UPDATE_LOG:

            return { ...state, id: action.payload.id, subject: action.payload.subject, topic: action.payload.topic, subtopic: action.payload.subtopic, comments: action.payload.comments };

        default:
            return state;
    }
}

export const openAIResponse = (state = {
    isLoading: true,
    errMess: null,
    openAIReponse: []
}, action) => {
    switch (action.type) {
        case ActionTypes.GET_OPEN_AI_RESPONSE:

            return { ...state, openAIReponse: action.payload};

        default:
            return state;
    }
}